import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { MultiSelect } from 'primereact/multiselect';
import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updatePlantasUsuarios } from '../../store/actions/proyectAction';

const PlantasUsuario = ({ plantas, currentUser, updatePlantasUsuarios }) => {
  const { t } = useTranslation();
  const [selectedPlantas, setSelectedPlantas] = useState(currentUser?.plantas);
  const [changedPlantas, setChangedPlantas] = useState(false);

  useEffect(() => {
    setSelectedPlantas(currentUser?.plantas);
    setChangedPlantas(false);
  }, [currentUser]);

  const updateValuePlantas = () => {
    try {
      updatePlantasUsuarios(currentUser, selectedPlantas);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Fragment>
      <div className="p-md-9 p-xs-12 ">
        <h3 className="floatLeft" style={{ marginBottom: '20px' }}>
          {t('Listado de plantas')}: {currentUser?.nombre}
        </h3>
        <div>
          <MultiSelect
            value={selectedPlantas || []}
            options={plantas || []}
            onChange={e => {
              setSelectedPlantas(e.target.value);
              setChangedPlantas(true);
            }}
            optionLabel="nombre"
            placeholder={t('Seleccione las plantas')}
            selectedItemsLabel={'{0} ' + t('plantas seleccionadas')}
            filter={true}
            className={'width350'}
          />
          <Button
            label={t('Guardar')}
            onClick={updateValuePlantas}
            disabled={!changedPlantas}
            className="p-button p-mr-2 p-mb-2 buttonColor text"
            style={{
              backgroundColor: '#10304C',
              color: '#f5a508',
              transform: 'translate(10px, 7px)',
            }}
          />
        </div>
      </div>
      <div style={{ padding: '10px' }}>
        {currentUser?.plantas ? (
          <div className="datatable-responsive-demo">
            <DataTable
              value={currentUser.plantas}
              selected="0"
              className="p-datatable-responsive-demo roboto"
              selectionMode="single"
              dataKey="id"
            >
              <Column field="nombre" header={t('Nombre')}></Column>
              <Column field="potenciapico" header={t('Potencia Pico')}></Column>
              <Column field="probjetivo" header={t('PR Objetivo')}></Column>
            </DataTable>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    </Fragment>
  );
};

const mapStateToProps = rootReducer => ({
  plantas: rootReducer.proyect.configuration.plantas,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updatePlantasUsuarios,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation('translations')(PlantasUsuario));
